import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { IOHMapService } from 'src/app/services/ioh-map.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'csx-base-maps',
  templateUrl: './ioh-base-maps.component.html',
  styleUrls: ['./ioh-base-maps.component.scss'],
  imports: [CommonModule, ButtonModule]
})
export class IOHBaseMapsComponent implements OnInit {
  constructor(public iohMapService: IOHMapService) {}
  @Output() hideBaseMaps: EventEmitter<boolean> = new EventEmitter<boolean>();
  ngOnInit(): void {}

  baseMapType: string = 'Dark';
  monoStyle = environment.appConfig.map.mapintermodalStyleMono;
  darkStyle = environment.appConfig.map.mapintermodalStyleDark;
  roadsStyle = environment.appConfig.map.mapintermodalStyleRoad;

  hideBaseMapView() {
    this.hideBaseMaps.emit(false);
  }

  switchSytle(style: string) {
    this.iohMapService.markStyleReloading();
    if (style === 'Mono') {
      this.iohMapService.iohMapType = 'Mono';
      this.iohMapService.map.setStyle(this.monoStyle);
    } else if (style === 'Dark') {
      this.iohMapService.iohMapType = 'Dark';
      this.iohMapService.map.setStyle(this.darkStyle);
    } else if (style === 'Roads') {
      this.iohMapService.iohMapType = 'Roads';
      this.iohMapService.map.setStyle(this.roadsStyle);
    }
    this.hideBaseMaps.emit(false);
    this.iohMapService.iohMapType = style;
    this.iohMapService.map.on('style.load', () => {
      this.iohMapService.displayIohL3Data();
    });

    const styleData = () => {
      if (this.iohMapService.map.isStyleLoaded()) {
        this.iohMapService.map.off('data', styleData);
      }
      this.baseMapType = style;
    };
    this.iohMapService.map.on('data', styleData);
  }
}
